import { render, staticRenderFns } from "./orderTable.vue?vue&type=template&id=4b975cd2"
import script from "./orderTable.vue?vue&type=script&lang=js"
export * from "./orderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b975cd2')) {
      api.createRecord('4b975cd2', component.options)
    } else {
      api.reload('4b975cd2', component.options)
    }
    module.hot.accept("./orderTable.vue?vue&type=template&id=4b975cd2", function () {
      api.rerender('4b975cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/payableManage/feesPayable/component/AddFeee/orderTable.vue"
export default component.exports